var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c("v-col", [_vm._t("default")], 2),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "ml-auto", attrs: { cols: "auto" } },
            [
              _vm.item.Tags
                ? _c("cc-tags", { attrs: { tags: _vm.item.Tags } })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-n1 mb-n4", attrs: { dense: "", justify: "center" } },
        _vm._l(_vm.synergies, function(s, i) {
          return _c(
            "v-col",
            {
              key: "syn_" + i,
              staticStyle: { "min-width": "30vw" },
              attrs: { cols: "auto" }
            },
            [
              _c(
                "v-alert",
                {
                  staticClass: "py-1",
                  attrs: { dense: "", outlined: "", color: "primary" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "overline my-n2 subtle--text" },
                    [
                      _vm._v("\n            ACTIVE SYNERGY\n            "),
                      _c("cc-slashes"),
                      _vm._v(" "),
                      _c("span", { staticClass: "text--text" }, [
                        _vm._v(_vm._s(s.Origin))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "body-text text--text",
                    domProps: { innerHTML: _vm._s(s.Detail) }
                  })
                ]
              )
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "v-slide-y-reverse-transition",
        [
          !_vm.confirmed
            ? _c(
                "v-container",
                { attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "mt-n1",
                      attrs: { dense: "", align: "center" }
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "mt-n5",
                          attrs: { lg: "auto", md: "12" }
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "text-center mb-n3",
                              attrs: {
                                dense: "",
                                justify: "start",
                                align: "start"
                              }
                            },
                            [
                              _vm.item.Range
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "mr-8",
                                      attrs: { cols: "auto" }
                                    },
                                    [
                                      _c("div", { staticClass: "overline" }, [
                                        _vm._v("Range")
                                      ]),
                                      _vm._v(" "),
                                      _c("cc-range-element", {
                                        staticClass: "d-inline",
                                        attrs: { range: _vm.getRange }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                {
                                  staticClass: "mx-8",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("div", { staticClass: "overline mb-n2" }, [
                                    _vm._v("Attack Roll")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "heading text--text",
                                      staticStyle: { "font-size": "24pt" }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-n1",
                                          attrs: { "x-large": "" }
                                        },
                                        [_vm._v("mdi-dice-d20-outline")]
                                      ),
                                      _vm._v(
                                        "\n                  + " +
                                          _vm._s(_vm.pilot.Grit) +
                                          "\n                "
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                {
                                  staticClass: "mx-8",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("div", { staticClass: "overline mb-n3" }, [
                                    _vm._v("vs. Target")
                                  ]),
                                  _vm._v(" "),
                                  _c("v-icon", {
                                    attrs: { "x-large": "" },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.isSmart ? "cci-edef" : "cci-evasion"
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "overline font-weight-bold mt-n2",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.isSmart ? "E-Defense" : "Evasion"
                                      )
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                {
                                  staticClass: "ml-8",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("div", { staticClass: "overline" }, [
                                    _vm._v("Damage")
                                  ]),
                                  _vm._v(" "),
                                  _c("cc-damage-element", {
                                    staticClass: "d-inline",
                                    attrs: { damage: _vm.getDamage }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "ml-auto",
                          attrs: { lg: "auto", md: "12" }
                        },
                        [
                          _c(
                            "v-row",
                            { attrs: { dense: "", justify: "end" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "ml-auto px-12 mr-n10 panel dual-sliced",
                                  staticStyle: { height: "70px" },
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "overline mt-n2 pl-1" },
                                    [_vm._v("Accuracy")]
                                  ),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    staticClass: "hide-input-spinners",
                                    staticStyle: { width: "115px" },
                                    attrs: {
                                      type: "number",
                                      "append-outer-icon":
                                        "mdi-plus-circle-outline",
                                      "append-icon": "cci-accuracy",
                                      "prepend-icon":
                                        "mdi-minus-circle-outline",
                                      color: "accent",
                                      dense: "",
                                      "hide-details": ""
                                    },
                                    on: {
                                      "click:append-outer": function($event) {
                                        _vm.accuracy < 99
                                          ? (_vm.accuracy += 1)
                                          : ""
                                      },
                                      "click:prepend": function($event) {
                                        _vm.accuracy > _vm.minAccuracy
                                          ? (_vm.accuracy -= 1)
                                          : ""
                                      },
                                      change: function($event) {
                                        _vm.accuracy = parseInt($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.accuracy,
                                      callback: function($$v) {
                                        _vm.accuracy = $$v
                                      },
                                      expression: "accuracy"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                {
                                  staticClass: "px-12 mr-n10 panel dual-sliced",
                                  staticStyle: { height: "70px" },
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "overline mt-n2 pl-1" },
                                    [_vm._v("Difficulty")]
                                  ),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    staticClass: "hide-input-spinners",
                                    staticStyle: { width: "115px" },
                                    attrs: {
                                      type: "number",
                                      "append-outer-icon":
                                        "mdi-plus-circle-outline",
                                      "append-icon": "cci-difficulty",
                                      "prepend-icon":
                                        "mdi-minus-circle-outline",
                                      color: "accent",
                                      dense: "",
                                      "hide-details": ""
                                    },
                                    on: {
                                      "click:append-outer": function($event) {
                                        _vm.difficulty < 99
                                          ? (_vm.difficulty += 1)
                                          : ""
                                      },
                                      "click:prepend": function($event) {
                                        _vm.difficulty > _vm.minDifficulty
                                          ? (_vm.difficulty -= 1)
                                          : ""
                                      },
                                      change: function($event) {
                                        _vm.difficulty = parseInt($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.difficulty,
                                      callback: function($$v) {
                                        _vm.difficulty = $$v
                                      },
                                      expression: "difficulty"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                {
                                  staticClass: "px-12 panel dual-sliced",
                                  staticStyle: { height: "70px" },
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "overline mt-n2 pl-1" },
                                    [_vm._v("Attack Roll")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { staticClass: "mr-n2 ml-n2" },
                                        [
                                          _c(
                                            "cc-tooltip",
                                            {
                                              attrs: {
                                                title: "Roll to Attack",
                                                content: _vm.attackRollTooltip
                                              }
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "mt-1 mr-n3",
                                                  attrs: {
                                                    icon: "",
                                                    small: "",
                                                    color: _vm.crit
                                                      ? "secondary"
                                                      : "accent"
                                                  },
                                                  on: { click: _vm.rollAttack }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { large: "" } },
                                                    [
                                                      _vm._v(
                                                        "mdi-dice-multiple"
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        [
                                          _c("v-text-field", {
                                            class:
                                              "hide-input-spinners ml-n3 " +
                                              (_vm.crit
                                                ? "font-weight-bold"
                                                : ""),
                                            staticStyle: {
                                              "max-width": "60px",
                                              "margin-top": "-0.5px"
                                            },
                                            attrs: {
                                              type: "number",
                                              color: _vm.crit
                                                ? "secondary"
                                                : "accent",
                                              dense: "",
                                              "hide-details": ""
                                            },
                                            model: {
                                              value: _vm.attackRoll,
                                              callback: function($$v) {
                                                _vm.attackRoll = $$v
                                              },
                                              expression: "attackRoll"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.crit
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "caption secondary--text font-weight-bold ml-8 my-n1"
                                        },
                                        [
                                          _vm._v(
                                            "\n                  CRITICAL\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                {
                                  staticClass: "ml-2 mt-n1",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        large: "",
                                        tile: "",
                                        block: "",
                                        disabled:
                                          _vm.attackFree || !_vm.attackRoll,
                                        color:
                                          (_vm.crit
                                            ? "secondary"
                                            : _vm.overwatch
                                            ? "action--reaction"
                                            : "action--full") +
                                          " " +
                                          (_vm.attackQuick ? "lighten-1" : "")
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.attackQuick = !_vm.attackQuick
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", { attrs: { left: "" } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.overwatch
                                              ? "cci-reaction"
                                              : "mdi-hexagon-slice-6"
                                          )
                                        )
                                      ]),
                                      _vm._v(
                                        "\n                  Attack\n                "
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        small: "",
                                        tile: "",
                                        block: "",
                                        disabled:
                                          _vm.attackQuick || !_vm.attackRoll,
                                        color:
                                          "action--free " +
                                          (_vm.attackFree ? "lighten-1" : "")
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.attackFree = !_vm.attackFree
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { left: "", small: "" } },
                                        [_vm._v("cci-free-action")]
                                      ),
                                      _vm._v(
                                        "\n                  Free Action\n                  "
                                      ),
                                      _c(
                                        "cc-tooltip",
                                        {
                                          attrs: {
                                            inline: "",
                                            content:
                                              "Special rules or equipment may allow you to Fight as a Free Action. Using this button will commit the attack without spending a Quick Action this turn"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "fadeSelect",
                                              attrs: { right: "", small: "" }
                                            },
                                            [_vm._v("mdi-information-outline")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-slide-x-reverse-transition",
                    [
                      _vm.attacked
                        ? _c(
                            "v-row",
                            { staticClass: "mt-n2", attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ml-auto",
                                  attrs: { md: "6", lg: "3", xl: "2" }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "primary",
                                      attrs: {
                                        tile: "",
                                        block: "",
                                        color:
                                          (_vm.crit ? "secondary" : "primary") +
                                          " " +
                                          (_vm.hit ? "lighten-1" : ""),
                                        disabled: _vm.missed
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.hit = !_vm.hit
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                HIT\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { md: "6", lg: "3", xl: "2" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        tile: "",
                                        block: "",
                                        disabled: _vm.hit,
                                        color: _vm.missed ? "error" : ""
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.missed = !_vm.missed
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                MISSED\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-slide-x-reverse-transition",
                    [
                      _vm.hit || _vm.missed
                        ? _c(
                            "v-row",
                            {
                              staticClass: "mt-1",
                              attrs: { dense: "", align: "center" }
                            },
                            [
                              _c("v-col", {
                                staticClass: "ml-auto",
                                attrs: { cols: "auto" }
                              }),
                              _vm._v(" "),
                              _vm.hit && _vm.crit
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: { cols: "auto" }
                                    },
                                    [
                                      _c(
                                        "cc-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "On a critical hit, all damage dice are rolled twice\n(including bonus damage) and the highest result from\neach source of damage is used."
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                "x-large": "",
                                                color: "secondary"
                                              }
                                            },
                                            [_vm._v("mdi-progress-alert")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "secondary--text" },
                                            [_vm._v("CRITICAL HIT")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hit
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "px-12 mr-n10 panel dual-sliced mt-n2",
                                      staticStyle: { height: "70px" },
                                      attrs: { cols: "auto" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "overline mt-n2 mb-n2 pl-1"
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.getDamage.length > 1
                                                  ? "Damage Rolls"
                                                  : "Damage Roll"
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-row",
                                        { attrs: { "no-gutters": "" } },
                                        [
                                          _c(
                                            "v-col",
                                            { staticClass: "mr-n2 ml-n2" },
                                            [
                                              _c(
                                                "cc-tooltip",
                                                {
                                                  attrs: {
                                                    title: "Roll Damage",
                                                    content:
                                                      _vm.damageRollTooltip
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "mt-1 mr-n3",
                                                      attrs: {
                                                        icon: "",
                                                        small: "",
                                                        color: _vm.crit
                                                          ? "secondary"
                                                          : "accent"
                                                      },
                                                      on: {
                                                        click: _vm.rollDamage
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: { large: "" }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-dice-multiple"
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-col",
                                            _vm._l(_vm.getDamage, function(
                                              d,
                                              i
                                            ) {
                                              return _c("v-text-field", {
                                                key: "rolled_damage_" + i,
                                                class:
                                                  "hide-input-spinners ml-n3 " +
                                                  (_vm.crit
                                                    ? "font-weight-bold"
                                                    : ""),
                                                staticStyle: {
                                                  "max-width": "60px",
                                                  "margin-top": "-0.5px"
                                                },
                                                attrs: {
                                                  type: "number",
                                                  color: _vm.crit
                                                    ? "secondary"
                                                    : "accent",
                                                  dense: "",
                                                  hint: d.Type,
                                                  "persistent-hint": ""
                                                },
                                                model: {
                                                  value: _vm.damageRolls[i],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.damageRolls,
                                                      i,
                                                      $$v
                                                    )
                                                  },
                                                  expression: "damageRolls[i]"
                                                }
                                              })
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hit
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "px-12 mr-n10 panel dual-sliced mt-n2",
                                      staticStyle: { height: "70px" },
                                      attrs: { cols: "auto" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "overline mt-n2 mb-n2 pl-1"
                                        },
                                        [_vm._v("Bonus Damage")]
                                      ),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        staticClass:
                                          "hide-input-spinners mt-n1 mb-2 ml-6",
                                        staticStyle: { width: "50px" },
                                        attrs: {
                                          type: "number",
                                          color: "accent",
                                          dense: "",
                                          "hide-details": ""
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.bonusDamage = parseInt($event)
                                          }
                                        },
                                        model: {
                                          value: _vm.bonusDamage,
                                          callback: function($$v) {
                                            _vm.bonusDamage = $$v
                                          },
                                          expression: "bonusDamage"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-slide-x-reverse-transition",
                                [
                                  _vm.hit
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass:
                                            "px-12 panel dual-sliced mt-n2",
                                          staticStyle: { height: "70px" },
                                          attrs: { cols: "auto" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "overline mt-n2 mb-n2 pl-1"
                                            },
                                            [_vm._v("Total Damage")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-row",
                                            {
                                              attrs: {
                                                "no-gutters": "",
                                                justify: "end"
                                              }
                                            },
                                            [
                                              _vm._l(_vm.getDamage, function(
                                                d,
                                                i
                                              ) {
                                                return _c(
                                                  "v-col",
                                                  {
                                                    key: "dm_result_" + i,
                                                    attrs: { cols: "auto" }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "heading h2 stark--text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.damageRolls[i]
                                                                ? _vm
                                                                    .damageRolls[
                                                                    i
                                                                  ]
                                                                : "--"
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                        _c(
                                                          "cc-tooltip",
                                                          {
                                                            attrs: {
                                                              inline: "",
                                                              content: d.Type
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "ml-n3",
                                                                attrs: {
                                                                  large: "",
                                                                  color: d.Color
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      d.Icon
                                                                    ) +
                                                                    "\n                        "
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              }),
                                              _vm._v(" "),
                                              _vm.bonusDamage
                                                ? _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "ml-n1",
                                                      attrs: { cols: "auto" }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "heading h2 stark--text",
                                                          staticStyle: {
                                                            "margin-top": "4px"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      +" +
                                                              _vm._s(
                                                                _vm.bonusDamage
                                                              ) +
                                                              "\n                    "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _vm.summedDamage
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "overline my-n3 pr-1 subtle--text text-right"
                                                },
                                                [
                                                  !!_vm.reliable &&
                                                  _vm.summedDamage <
                                                    _vm.reliable
                                                    ? _c(
                                                        "b",
                                                        {
                                                          staticClass:
                                                            "accent--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    (" +
                                                              _vm._s(
                                                                _vm.reliable
                                                              ) +
                                                              ")\n                  "
                                                          )
                                                        ]
                                                      )
                                                    : _c("span", [
                                                        _vm._v(
                                                          "(" +
                                                            _vm._s(
                                                              _vm.summedDamage
                                                            ) +
                                                            ")"
                                                        )
                                                      ])
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-slide-x-reverse-transition",
                                [
                                  (_vm.missed && !!_vm.reliable) ||
                                  (_vm.summedDamage &&
                                    !!_vm.reliable &&
                                    _vm.summedDamage < _vm.reliable)
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass:
                                            "text-center mt-1 ml-n5 mr-6",
                                          attrs: { cols: "auto" }
                                        },
                                        [
                                          _c(
                                            "cc-tooltip",
                                            {
                                              attrs: {
                                                content:
                                                  "This attack deals a minimum of " +
                                                  _vm.reliable +
                                                  " damage"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { "x-large": "" } },
                                                [_vm._v("mdi-progress-alert")]
                                              ),
                                              _vm._v(" "),
                                              _c("div", [
                                                _vm._v(
                                                  "RELIABLE " +
                                                    _vm._s(_vm.reliable)
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-slide-x-reverse-transition",
                                [
                                  _vm.hit || _vm.missed
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass:
                                            "text-center mt-n2 mb-n5 ml-n4",
                                          attrs: { cols: "auto" }
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "mt-2",
                                              attrs: { "no-gutters": "" }
                                            },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "ml-auto",
                                                  attrs: { cols: "auto" }
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        large: "",
                                                        tile: "",
                                                        color:
                                                          "success darken-2",
                                                        disabled:
                                                          _vm.hit &&
                                                          !_vm.summedDamage
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.confirm()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        { attrs: { left: "" } },
                                                        [_vm._v("mdi-check")]
                                                      ),
                                                      _vm._v(
                                                        "\n                      Confirm\n                    "
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.hit ||
                                          (_vm.missed && !!_vm.reliable)
                                            ? _c(
                                                "v-row",
                                                {
                                                  staticClass: "mt-n4",
                                                  attrs: { "no-gutters": "" }
                                                },
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "ml-auto",
                                                      attrs: { cols: "auto" }
                                                    },
                                                    [
                                                      _c(
                                                        "v-checkbox",
                                                        {
                                                          attrs: {
                                                            color: "accent",
                                                            dense: "",
                                                            disabled:
                                                              _vm.hit &&
                                                              !_vm.summedDamage
                                                          },
                                                          model: {
                                                            value: _vm.kill,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.kill = $$v
                                                            },
                                                            expression: "kill"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "caption",
                                                              attrs: {
                                                                slot: "label"
                                                              },
                                                              slot: "label"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "TARGET DESTROYED"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("v-slide-x-reverse-transition", [
        _vm.hit || _vm.missed
          ? _c(
              "div",
              { staticClass: "mt-2 text-right", attrs: { "no-gutters": "" } },
              [
                _c(
                  "cc-tooltip",
                  {
                    attrs: {
                      inline: "",
                      content:
                        "Undo this attack, refunding any actions it may have cost"
                    }
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "fadeSelect",
                        attrs: { "x-small": "", color: "primary" },
                        on: { click: _vm.reset }
                      },
                      [
                        _c("v-icon", { attrs: { small: "", left: "" } }, [
                          _vm._v("mdi-reload")
                        ]),
                        _vm._v("\n            UNDO\n          ")
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }